import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { Business, BusinessState } from "./types";
import { searchBusinesses, fetchBusinessDetailsAPI } from "./businessAPI";

const initialState: BusinessState = {
  businesses: [],
  selectedBusiness: null,
  loading: false,
  error: null,
};

export const fetchBusinesses = createAsyncThunk(
  "business/fetchAll",
  async (params: { query?: string; lat?: number; lng?: number }) => {
    return await searchBusinesses(params);
  }
);

export const fetchBusinessDetails = createAsyncThunk(
  "business/fetchDetails",
  async (id: string) => {
    return await fetchBusinessDetailsAPI(id);
  }
);

const businessSlice = createSlice({
  name: "business",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBusinesses.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        fetchBusinesses.fulfilled,
        (state, action: PayloadAction<Business[]>) => {
          state.loading = false;
          state.businesses = action.payload;
        }
      )
      .addCase(
        fetchBusinessDetails.fulfilled,
        (state, action: PayloadAction<Business>) => {
          state.selectedBusiness = action.payload;
        }
      )
      .addCase(fetchBusinesses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Failed to load businesses";
      });
  },
});

export default businessSlice.reducer;
